(function () {
  if (window.dbAccessoriesInitialized) return;
  window.dbAccessoriesInitialized = true;
  var submissionStates = new WeakMap();

  function restoreSubmission(root) {
    var state = submissionStates.get(root);
    if (!state) return;
    state.button.disabled = state.disabled;
    state.button.value = state.label;
    state.button.removeAttribute("aria-busy");
    state.wrapper?.classList.remove("has-halo-block-loader");
    submissionStates.delete(root);
  }

  window.addEventListener("pageshow", function (event) {
    if (!event.persisted) return;
    document.querySelectorAll("[data-db-accessories-root]").forEach(restoreSubmission);
  });

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, window.money_format);
    }
    return (cents / 100).toFixed(2);
  }

  function redirectTo(url) {
    try {
      if (window.self !== window.top && !window.iframeSdk && !Shopify.designMode) {
        window.top.location = url;
        return;
      }
    } catch (e) {}
    window.location = url;
  }

  function getSelectedItems(root) {
    return Array.from(root.querySelectorAll(".db-accessory-item")).filter(function (item) {
      var checkbox = item.querySelector('.db-accessories-check input[type="checkbox"]');
      return checkbox && checkbox.checked;
    });
  }

  function syncItemState(item) {
    var checkbox = item.querySelector('.db-accessories-check input[type="checkbox"]');
    item.classList.toggle("isChecked", !!checkbox && checkbox.checked);
  }

  function updateItemVariantDisplay(item, selectEl) {
    var option = selectEl && selectEl.selectedOptions ? selectEl.selectedOptions[0] : null;
    if (!option) return;

    var priceRegular = item.querySelector("[data-bundle-product-price]");
    var oldPrice = item.querySelector(".db-accessories-old-price");
    var image = item.querySelector(".bundle-product-image img");
    var isFree = item.dataset.dbIsFree === "1";

    var price = option.dataset.price ? parseInt(option.dataset.price, 10) : 0;
    var comparePrice = option.dataset.comparePrice ? parseInt(option.dataset.comparePrice, 10) : price;

    if (isFree) {
      if (oldPrice) oldPrice.innerHTML = formatMoney(comparePrice);
    } else if (priceRegular) {
      priceRegular.innerHTML = formatMoney(price);
    }

    if (image && option.dataset.image) {
      image.src = option.dataset.image;
      image.srcset = option.dataset.image;
    }
  }

  function getVariantIdAndPrice(item) {
    var select = item.querySelector('select[name="group_id"]');
    if (select) {
      var option = select.selectedOptions ? select.selectedOptions[0] : null;
      if (!option) return null;
      return {
        id: parseInt(select.value, 10),
        price: option.dataset.price ? parseFloat(option.dataset.price) : 0
      };
    }

    var input = item.querySelector('input[name="group_id"]');
    if (!input) return null;
    return {
      id: parseInt(input.value, 10),
      price: input.dataset.price ? parseFloat(input.dataset.price) : 0
    };
  }

  async function onSubmit(root, event) {
    event.preventDefault();

    var form = root.querySelector("form.db-combo-form");
    if (!form || submissionStates.has(root)) return;

    var submitBtn = form.querySelector('[data-combo-addtocart]');
    var wrapper = form.querySelector(".bundle-product-wrapper");
    var mainVariantInput = form.querySelector('input[name="id"]');
    var mainVariantId = mainVariantInput ? parseInt(mainVariantInput.value, 10) : null;
    var productId = root.dataset.productId;
    var discountCode = "COMBO-" + productId;
    var selected = getSelectedItems(root);
    if (!submitBtn || submitBtn.disabled || !mainVariantId) return;
    submissionStates.set(root, {button: submitBtn, wrapper: wrapper, disabled: submitBtn.disabled, label: submitBtn.value});
    submitBtn.disabled = true;
    submitBtn.setAttribute("aria-busy", "true");

    if (wrapper) wrapper.classList.add("has-halo-block-loader");
    if (submitBtn && window.variantStrings) submitBtn.value = window.variantStrings.addingToCart;

    try {
      var cartRes = await fetch("/cart.js");
      var cart = await cartRes.json();
      var parts = [];

      (cart.items || []).forEach(function (line) {
        parts.push(line.id + ":" + line.quantity);
      });

      if (mainVariantId) parts.push(mainVariantId + ":1");

      var selectedMeta = [];
      selected.forEach(function (item) {
        var vp = getVariantIdAndPrice(item);
        if (!vp || !vp.id) return;
        parts.push(vp.id + ":1");
        selectedMeta.push({
          productId: parseInt(item.dataset.bundleProductItemId, 10),
          variantId: vp.id,
          price: vp.price,
          isFree: item.dataset.dbIsFree === "1"
        });
      });

      await fetch("/cart/" + parts.join(","), { mode: "no-cors" });

      if (selectedMeta.length > 0) {
        var total = 0;
        var free = 0;
        var items = [];
        selectedMeta.forEach(function (x) {
          total += x.price;
          if (x.isFree) free += x.price;
          items.push(x.productId);
        });
        items.push(parseInt(productId, 10));

        var bundleDiscountRate = total > 0 ? free / total : 0;
        var payload = {
          attributes: {
            checkout_level_applications: [
              { name: discountCode, bundleDiscountRate: bundleDiscountRate, items: items }
            ]
          }
        };

        localStorage.setItem("storedDiscount", discountCode);
        await fetch((window.routes && window.routes.cart_update_url) ? window.routes.cart_update_url : "/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(payload)
        });

        await fetch("/discount/" + discountCode + "?redirect=/cart");
      } else {
        localStorage.removeItem("storedDiscount");
      }

      if (submitBtn && window.variantStrings) {
        submitBtn.value = window.variantStrings.addedToCart;
        submitBtn.disabled = true;
      }
      redirectTo((window.routes && window.routes.cart) ? window.routes.cart : "/cart");
    } catch (e) {
      console.error(e);
      restoreSubmission(root);
    }
  }

  function initDbAccessories(root) {
    if (!root || root.dataset.dbAccessoriesBound === "1") return;
    root.dataset.dbAccessoriesBound = "1";

    root.querySelectorAll(".db-accessory-item").forEach(function (item) {
      syncItemState(item);
    });

    root.addEventListener("change", function (event) {
      var checkbox = event.target.closest('.db-accessories-check input[type="checkbox"]');
      if (checkbox) {
        var item = checkbox.closest(".db-accessory-item");
        if (item) syncItemState(item);
        return;
      }

      var selectEl = event.target.closest('select[name="group_id"].db-accessories-variant-select');
      if (selectEl) {
        var item = selectEl.closest(".db-accessory-item");
        if (item) updateItemVariantDisplay(item, selectEl);
      }
    });

    var form = root.querySelector("form.db-combo-form");
    if (form) {
      form.addEventListener("submit", onSubmit.bind(null, root));
    }
  }

  function initAll() {
    document.querySelectorAll("[data-db-accessories-root]").forEach(initDbAccessories);
  }

  function observeNewRoots() {
    if (!document.body || typeof MutationObserver === "undefined") return;
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          if (node.matches && node.matches("[data-db-accessories-root]")) {
            initDbAccessories(node);
          }
          if (node.querySelectorAll) {
            node.querySelectorAll("[data-db-accessories-root]").forEach(initDbAccessories);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll();
      observeNewRoots();
    });
  } else {
    initAll();
    observeNewRoots();
  }
})();
